<template>
  <div class="text-center">
    <v-menu
      v-model="menuOpened"
      origin="right top"
      :close-on-content-click="false"
      :nudge-width="300"
      transition="scale-transition"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-btn icon
               v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-card v-if="loading" class="text-center">
        <v-card-text>
          <div class="text-center">
            <v-progress-circular color="secondary" indeterminate v-bind="$attrs" v-on="$listeners"/>
          </div>
        </v-card-text>
      </v-card>
      <v-card v-if="!loading">
        <v-container>
          <v-row>
            <v-spacer />
            <v-btn large icon @click="menuOpened = false" style="margin-right: 12px;">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
          <v-row align="center" justify="center">
            <v-avatar color="blue" size="62">
              <img src="../../assets/default-user1.png" alt="Usuário">
            </v-avatar>
          </v-row>
          <v-container v-if="user">
            <v-row class="v-list-item__title" align="center" justify="center">
              <span>{{user.nome}}</span>
            </v-row>
            <v-row class="v-list-item__subtitle" align="center" justify="center">
              <span>{{user.email}}</span>
            </v-row>
          </v-container>
          <v-container>
            <v-row align="center" justify="center">
              <v-btn link
                to="/minha-conta"
                rounded
                outlined
                @click="menuOpened = false">Gerenciar minha conta</v-btn>
            </v-row>
          </v-container>
        </v-container>
        <v-divider/>
        <v-container>
          <v-row align="center" justify="center">
            <v-btn color="primary" depressed @click="logout">Sair</v-btn>
          </v-row>
        </v-container>
        <!--<v-divider/>
        <v-container>
          <v-row align="center" justify="center">
            <v-btn tag="a" text x-small
                   href="https://twsystema.com.br/termos-uso/"
                   target="_blank"
                   @click="menuOpened = false">
              Termos de uso
            </v-btn>
          </v-row>
        </v-container>
        -->
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FETCH_USER } from '@/store/user/actions.type';
import { LOGOUT } from '@/store/auth/actions.type';

export default {
  data: () => ({
    menuOpened: false,
    aceiteTermo: false,
  }),
  computed: {
    ...mapGetters('user', ['user', 'loading']),
  },
  methods: {
    ...mapActions('user', {
      getUser: FETCH_USER,
    }),
    logout() {
      this.menu = false;
      this.$store.dispatch(LOGOUT);
      window.open('https://agendaplus.com.br/', '_self');
    },
    onTermoAceito() {
      this.aceiteTermo = false;
    },
  },
  created() {
    this.getUser()
      .then(() => {
        if (!this.user.termoAceito) {
          this.aceiteTermo = true;
        }
      });
  },
};
</script>
